import { render, staticRenderFns } from "./NormativaContainer.vue?vue&type=template&id=1d299da3&scoped=true"
import script from "./NormativaContainer.vue?vue&type=script&lang=js"
export * from "./NormativaContainer.vue?vue&type=script&lang=js"
import style0 from "./NormativaContainer.vue?vue&type=style&index=0&id=1d299da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d299da3",
  null
  
)

export default component.exports